import { render, staticRenderFns } from "./DadosProgressHeader.vue?vue&type=template&id=c43b59ce&scoped=true"
import script from "./DadosProgressHeader.vue?vue&type=script&lang=js"
export * from "./DadosProgressHeader.vue?vue&type=script&lang=js"
import style0 from "./DadosProgressHeader.vue?vue&type=style&index=0&id=c43b59ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43b59ce",
  null
  
)

export default component.exports